import React, { useState } from "react";
import axios from "axios";
import "./VentasConsulta.css";
import Swal from "sweetalert2";

const VentasConsulta = () => {
  const [productoIdConsulta, setProductoIdConsulta] = useState("");
  const [resultados, setResultados] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [loading, setLoading] = useState(false);

  const buscarSucursales = async () => {
    if (!productoIdConsulta) {
      Swal.fire({
        title: "Campo incompleto",
        text: "Debes ingresar el ID del producto.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setBusquedaRealizada(true);
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_URL}/api/catalogo/${productoIdConsulta}`;
      const response = await axios.get(url);
      setResultados(response.data);
    } catch (error) {
      console.error("Error al buscar sucursales:", error);
      setResultados([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ventas-consulta-container">
      <h2>Consultar Producto</h2>
      <div className="input-container">
        <input
          type="text"
          placeholder="ID de Producto"
          value={productoIdConsulta}
          onChange={(e) => setProductoIdConsulta(e.target.value)}
        />
        <button onClick={buscarSucursales} disabled={loading}>
          {loading ? "Buscando..." : "Consultar"}
        </button>
      </div>

      {loading && <div className="loading-spinner"></div>}

      {busquedaRealizada && !loading && resultados.length === 0 && (
        <p className="error-message">No se encontraron sucursales con este producto.</p>
      )}

      {resultados.length > 0 && !loading && (
        <table>
          <thead>
            <tr>
              <th>Sucursal</th>
              <th>Producto</th>
              <th>ID Producto</th>
            </tr>
          </thead>
          <tbody>
            {resultados.map((item) => (
              <tr key={item._id}>
                <td>{item.sucursal}</td>
                <td>{item.productos[0]?.nombre}</td>
                <td>{item.productos[0]?.producto_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default VentasConsulta;
